import React, { useEffect, useState } from "react";
import SIngleProduct from "../AllProduct/SIngleProduct";
import "./Product.css";
import axios  from "axios";

const Product = (props) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios.get("https://skabelse.herokuapp.com/painting/").then((res) => {
      setProducts(res.data);
    });
  }, []);
  return (
    <>
      <div className={`productCategory d-flex ${props.background}`}>
        <div className="productCard">
          {/* Single Card */}
          {products.map((product) => (
                <SIngleProduct
                  key={product.id}
                  product={product}
                ></SIngleProduct>
              ))}
        </div>
      </div>
    </>
  );
};

export default Product;
